module.exports = __webpack_public_path__ + "static/media/logo-light.b4c4adb2.png";